import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MODE_SPECIFIC_DATA } from '../{components,pages,hooks,utils,styles}/constants/constants.js';
import API_URL from '../config/api.js';
import axios from 'axios';
import '../styles/CustomerForm.css';
import PaymentForm from '../components/PaymentForm';
import CalendlyField from '../components/CalendlyField.jsx';

function CustomerForm() {
  const { formId } = useParams();
  const [formConfig, setFormConfig] = useState(null);
  const [formData, setFormData] = useState({});
  const [files, setFiles] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [unlocked, setUnlocked] = useState(false);
  const [payments, setPayments] = useState({});
  const [bookings, setBookings] = useState({});
  const [modeConfig, setModeConfig] =  useState()

  useEffect(() => {
    loadFormConfig();
    console.log('API_URL:', API_URL);
  }, [formId]);



  // Listen for unlock code "yourdad"
  useEffect(() => {
    const handleKeyPress = (e) => {
      const key = e.key.toLowerCase();
      if (!window.unlockBuffer) window.unlockBuffer = '';
      window.unlockBuffer += key;
      
      if (window.unlockBuffer.length > 7) {
        window.unlockBuffer = window.unlockBuffer.slice(-7);
      }
      
      if (window.unlockBuffer.includes('yourdad')) {
        setUnlocked(true);
        window.unlockBuffer = '';
        console.log('🔓 Form unlocked for editing');
      }
    };
    
    window.addEventListener('keypress', handleKeyPress);
    return () => window.removeEventListener('keypress', handleKeyPress);
  }, []);

  const loadFormConfig = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/referrals/form/${formId}`);
      console.log('Form config loaded:', response.data);
      setFormConfig(response.data);
      setModeConfig(MODE_SPECIFIC_DATA[response.data?.form.mode]);
      console.log(`Mode Date: ${modeConfig}`)
      try {
        const existingResponse = await axios.get(`${API_URL}/api/referrals/form/${formId}/response`);
        if (existingResponse.data.response) {
          const savedResponse = existingResponse.data.response;
          setFormData(savedResponse.responses || {});
          if (savedResponse.files) {
              setFiles(savedResponse.files);
            };
          setAlreadySubmitted(true);
          return;
        }
      } catch (err) {
        console.log('No existing response (expected for new forms):', err.response?.status);
      }
      
      // Try to load saved draft from localStorage
      const savedDraft = localStorage.getItem(`form-draft-${formId}`);
      if (savedDraft) {
        const draft = JSON.parse(savedDraft);
        setFormData(draft.responses || {});
        console.log('Loaded draft from', draft.savedAt);
      } else {
        // Initialize form data
        console.log('Initializing empty form data');
        const initialData = {};
        response.data.form.fields.forEach(field => {
          initialData[field.id] = field.type === 'multiple-choice' ? [] : '';
        });
        setFormData(initialData);
      }
    } catch (error) {
      console.error('Error loading form:', error);
    } finally {
      setLoading(false);
    }
  };

  // Auto-save draft every time formData changes
  useEffect(() => {
    if (formConfig && Object.keys(formData).length > 0) {
      localStorage.setItem(`form-draft-${formId}`, JSON.stringify({
        responses: formData,
        savedAt: new Date().toISOString(),
      }));
    }
  }, [formData, formId, formConfig]);

  const handleChange = (fieldId, value) => {
    setFormData(prev => ({ ...prev, [fieldId]: value }));
  };

  const handleMultipleChoice = (fieldId, option) => {
    setFormData(prev => {
      const currentValues = prev[fieldId] || [];
      const isSelected = currentValues.includes(option);
      
      return {
        ...prev,
        [fieldId]: isSelected
          ? currentValues.filter(v => v !== option)
          : [...currentValues, option]
      };
    });
  };

  const handleFileUpload = async (fieldId, file) => {
    setFiles(prev => ({ ...prev, [fieldId]: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    console.log(`mode Config: ${JSON.stringify(modeConfig)}`)
    try {
      const fileKeys = {};
      
      for (const [fieldId, file] of Object.entries(files)) {
        if (Array.isArray(file)){
          const uploadedKeys = [];
          for (const singleFile of file){
            if (typeof singleFile === 'string'){
              uploadedKeys.push(singleFile);
            } else if (singleFile instanceof File) {
              const formDataObj = new FormData();
              formDataObj.append('file', singleFile);
              formDataObj.append('fieldId', fieldId);
              formDataObj.append('formId', formId);

              const uploadResponse = await axios.post(`${API_URL}/api/referrals/upload`, formDataObj, { 
                headers: { 'Content-Type': 'multipart/form-data' } 
              });

              uploadedKeys.push(uploadResponse.data.key)
            }
          }
          fileKeys[fieldId] = uploadedKeys
        } else if (typeof file === 'string') {
          if (file.startsWith('/api/files/')){
            fileKeys[fieldId] = file.replace('/api/files/', '');
          } else {
            fileKeys[fieldId] = file;
          }
          continue;
        }
        
        if (file instanceof File) {
          const formDataObj = new FormData();
          formDataObj.append('file', file);
          formDataObj.append('fieldId', fieldId);
          formDataObj.append('formId', formId);
          
          const uploadResponse = await axios.post(`${API_URL}/api/referrals/upload`, formDataObj, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });
          
          fileKeys[fieldId] = uploadResponse.data.key;
        }
      }


      const submitData = {
        formId,
        responses: formData,
        files: fileKeys,
        payments: payments,
        bookings: bookings
      };
      const headers = {
        'Content-Type': 'application/json'
      }
      const token = localStorage.getItem('authToken');
      if(token){
        headers['Authorization'] = `Bearer ${token}`
      }

      await axios.post(
          `${API_URL}${modeConfig?.updateEndpoint || '/api/referrals/customer-response'}`,
          submitData,
          {headers}
        );
      
      console.log('Checking remainingForms in localStorage...');
      const remainingForms = JSON.parse(localStorage.getItem('remainingForms') || '[]');
      console.log('Remaining forms:', remainingForms);
      console.log('Number of remaining forms:', remainingForms.length);


      
      setSubmitted(true);
      
      setTimeout(() => {
        const remainingForms = JSON.parse(localStorage.getItem('remainingForms') || '[]');
        console.log('In setTimeout - remaining forms:', remainingForms);
        
        if (remainingForms.length > 0) {
          const nextForm = remainingForms[0];
          console.log('Next form object:', nextForm);
          localStorage.setItem('remainingForms', JSON.stringify(remainingForms.slice(1)));
          
          // Handle both object with url property and direct URL string
          const nextUrl = typeof nextForm === 'string' ? nextForm : nextForm.url;
          console.log('Redirecting to:', nextUrl);
          window.location.href = nextUrl;
        } else {
          console.log('No more forms, going to thank you');
          localStorage.removeItem('remainingForms');
          window.location.href = '/thank-you/form-submission';
        }
      }, 2000);
    } catch (error) {
      console.error('Submission error:', error);
      alert('There was an error submitting your form. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const handlePaymentSuccess = (fieldId, paymentData) => {
    console.log('Payment successful:', fieldId, paymentData);
    setPayments(prev => ({ ...prev, [fieldId]: paymentData }));
  };
  
  const handleBookingScheduled = (fieldId, bookingData) => {
    console.log('Booking scheduled:', fieldId, bookingData);
    setBookings(prev => ({ ...prev, [fieldId]: bookingData }));
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading form...</p>
      </div>
    );
  }

  if (!formConfig) {
    return (
      <div className="error-container">
        <h2>Form Not Found</h2>
        <p>The form you're looking for doesn't exist or has been removed.</p>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="success-message">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 200 }}
        >
          <div className="success-icon">✓</div>
          <h2>Form Submitted!</h2>
          <p>Thank you for completing the form.</p>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="customer-form-page">
      <div className="customer-hero">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="hero-content"
        >
          <img 
            src="https://i.imgur.com/DAg1a53.png" 
            alt="1Solar Logo" 
            className="hero-logo"
          />
          <h1>{formConfig.form.productName} Information</h1>
          <p>Please complete the following information</p>
        </motion.div>
      </div>

      <div className="container">
        {alreadySubmitted && (
          <div className={`already-submitted-banner ${unlocked ? 'unlocked' : ''}`}>
            <p>
              {unlocked ? (
                <>🔓 Form unlocked for editing. You can now modify all fields and resubmit.</>
              ) : (
                <>🔒 This form has been submitted and is now locked to prevent accidental changes.</>
              )}
            </p>
          </div>
        )}
        
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="form-wrapper"
        >
          <form onSubmit={handleSubmit} className="customer-form">
            {formConfig.form.fields.map((field, index) => (
              <motion.div
                key={field.id}
                className="form-field"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <label className="field-label">
                  {field.label}
                  {field.required && <span className="required">*</span>}
                </label>

                {field.type === 'text' && (
                  <input
                    type="text"
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                    placeholder={field.placeholder}
                    required={field.required}
                    disabled={alreadySubmitted && !unlocked}
                    className="field-input"
                    style={alreadySubmitted && !unlocked ? { background: '#f7fafc', cursor: 'not-allowed' } : {}}
                  />
                )}

                {field.type === 'textarea' && (
                  <textarea
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                    placeholder={field.placeholder}
                    required={field.required}
                    disabled={alreadySubmitted && !unlocked}
                    rows={4}
                    className="field-textarea"
                    style={alreadySubmitted && !unlocked ? { background: '#f7fafc', cursor: 'not-allowed' } : {}}
                  />
                )}

                {field.type === 'number' && (
                  <input
                    type="number"
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                    placeholder={field.placeholder}
                    required={field.required}
                    disabled={alreadySubmitted && !unlocked}
                    className="field-input"
                    style={alreadySubmitted && !unlocked ? { background: '#f7fafc', cursor: 'not-allowed' } : {}}
                  />
                )}
                {field.type === 'date' && (
                  <input
                    type="date"
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                    min={field.minDate || undefined}
                    max={field.maxDate || undefined}
                    required={field.required}
                    disabled={alreadySubmitted && !unlocked}
                    className="field-input"
                  />
                )}
                {field.type === 'section' && (
                  <div className="section-header-field">
                    <h3>{field.label}</h3>
                    {field.sectionDescription && (
                      <p>{field.sectionDescription}</p>
                    )}
                  </div>
                )}

                {field.type === 'multiple-choice' && (
                  <div className="choice-options">
                    {field.selectionType === 'single' ? (
                      // Radio buttons (single select)
                      field.options.map((option) => (
                        <label key={option} className="choice-option" style={alreadySubmitted && !unlocked ? { cursor: 'not-allowed', opacity: 0.6 } : {}}>
                          <input
                            type="radio"
                            name={field.id}
                            value={option}
                            checked={formData[field.id] === option}
                            onChange={(e) => handleChange(field.id, e.target.value)}
                            disabled={alreadySubmitted && !unlocked}
                          />
                          <span>{option}</span>
                        </label>
                      ))
                    ) : (
                      // Checkboxes (multi-select) - existing code
                      field.options.map((option) => (
                        <label key={option} className="choice-option" style={alreadySubmitted && !unlocked ? { cursor: 'not-allowed', opacity: 0.6 } : {}}>
                          <input
                            type="checkbox"
                            checked={(formData[field.id] || []).includes(option)}
                            onChange={() => handleMultipleChoice(field.id, option)}
                            disabled={alreadySubmitted && !unlocked}
                          />
                          <span>{option}</span>
                        </label>
                      ))
                    )}
                  </div>
                )}
                {field.type === 'payment' && (
                  <PaymentForm
                    field={field}
                    formId={formId}
                    customerEmail={formConfig.customerResponse?.customerEmail || formData.email || ''}
                    customerName={formConfig.customerResponse?.customerName || formData.name || ''}
                    onPaymentSuccess={handlePaymentSuccess}
                  />
                )}
                {field.type === 'calendly' && (
                  <CalendlyField
                    field={field}
                    name={formConfig.customerResponse?.customerName || ''}
                    email={formConfig.customerResponse?.customerEmail || ''}
                    phone={formConfig.customerResponse?.customerPhone || ''}
                    address={formConfig.customerResponse?.customerAddress || ''}
                    formId={formId}
                    onBookingScheduled={handleBookingScheduled}
                  />
                )} 

                {field.type === 'file-upload' && (
                  <div className="file-upload-area">
                    {(!alreadySubmitted || unlocked) && (
                      <>
                        <input
                          type="file"
                          id={`file-${field.id}`}
                          onChange={(e) => {
                            if (field.allowMultiple) {
                              handleFileUpload(field.id, Array.from(e.target.files));
                            } else {
                              handleFileUpload(field.id, e.target.files[0]);
                            }
                          }}
                          accept={field.acceptedTypes || '*'}
                          required={field.required && !files[field.id]}
                          multiple={field.allowMultiple || false}
                          className="file-input"
                        />
                        <label htmlFor={`file-${field.id}`} className="file-label">
                          <span className="upload-icon">📎</span>
                          {files[field.id] ? 
                            (Array.isArray(files[field.id]) 
                              ? `${files[field.id].length} file(s) selected`
                              : typeof files[field.id] === 'string' 
                                ? 'File uploaded ✓' 
                                : files[field.id].name
                            ) : 
                            (field.allowMultiple ? 'Choose files or drag here' : 'Choose file or drag here')
                          }
                        </label>
                      </>
                    )}
                    
                    {files[field.id] && (
                      <div className="file-preview">
                        {/* Single file preview (existing logic) */}
                        {!Array.isArray(files[field.id]) && typeof files[field.id] === 'object' && files[field.id].type?.startsWith('image/') && (
                          <img 
                            src={URL.createObjectURL(files[field.id])} 
                            alt="Preview" 
                            style={{ maxWidth: '200px', maxHeight: '200px', marginTop: '10px', borderRadius: '8px' }}
                          />
                        )}
                        
                        {/* Single file - Already uploaded (string = S3 key) */}
                        {typeof files[field.id] === 'string' && (
                          <div style={{ marginTop: '10px' }}>
                            <img 
                              src={`${API_URL}/api/files/${files[field.id]}`}  
                              alt="Uploaded file" 
                              style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '8px', display: 'block', marginBottom: '10px' }}
                              onError={(e) => { e.target.style.display = 'none'; }}
                            />
                            <a 
                              href={`${API_URL}/api/files/${files[field.id]}`}  
                              target="_blank" 
                              rel="noopener noreferrer"
                              style={{
                                display: 'inline-block',
                                padding: '8px 16px',
                                background: '#4299E1',
                                color: 'white',
                                borderRadius: '8px',
                                textDecoration: 'none',
                                fontSize: '14px',
                                fontWeight: '600',
                              }}
                            >
                              📥 Download File
                            </a>
                          </div>
                        )}
                        
                        {/* Multiple files preview */}
                        {Array.isArray(files[field.id]) && (
                          <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {files[field.id].map((file, index) => (
                              <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px', background: '#f7fafc', borderRadius: '8px' }}>
                                {typeof file === 'object' && file.type?.startsWith('image/') && (
                                  <img 
                                    src={URL.createObjectURL(file)} 
                                    alt={`Preview ${index + 1}`} 
                                    style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px' }}
                                  />
                                )}
                                <span style={{ flex: 1, fontSize: '14px' }}>
                                  {typeof file === 'string' ? `File ${index + 1}` : file.name}
                                </span>
                                {typeof file === 'string' && (
                                  <a 
                                    href={`${API_URL}/api/files/${file}`}  
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{
                                      padding: '4px 12px',
                                      background: '#4299E1',
                                      color: 'white',
                                      borderRadius: '4px',
                                      textDecoration: 'none',
                                      fontSize: '12px',
                                    }}
                                  >
                                    📥
                                  </a>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
                {field.type === 'email' && (
                  <input
                    type="email"
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                    placeholder={field.placeholder}
                    required={field.required}
                    disabled={alreadySubmitted && !unlocked}
                    className="field-input"
                    style={alreadySubmitted && !unlocked ? { background: '#f7fafc', cursor: 'not-allowed' } : {}}
                  />
                )}

                {field.type === 'phone' && (
                  <input
                    type="tel"
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                    placeholder={field.placeholder}
                    required={field.required}
                    disabled={alreadySubmitted && !unlocked}
                    className="field-input"
                    style={alreadySubmitted && !unlocked ? { background: '#f7fafc', cursor: 'not-allowed' } : {}}
                  />
                )}

                {field.type === 'url' && (
                  <input
                    type="url"
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                    placeholder={field.placeholder}
                    required={field.required}
                    disabled={alreadySubmitted && !unlocked}
                    className="field-input"
                    style={alreadySubmitted && !unlocked ? { background: '#f7fafc', cursor: 'not-allowed' } : {}}
                  />
                )}

                {field.type === 'dropdown' && (
                  <select
                    value={formData[field.id] || ''}
                    onChange={(e) => handleChange(field.id, e.target.value)}
                    required={field.required}
                    disabled={alreadySubmitted && !unlocked}
                    className="field-input"
                    style={alreadySubmitted && !unlocked ? { background: '#f7fafc', cursor: 'not-allowed' } : {}}
                  >
                    <option value="">Select an option...</option>
                    {field.options.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                )}

                {field.description && (
                  <p className="field-description">{field.description}</p>
                )}
              </motion.div>
            ))}

            <motion.button
              type="submit"
              className="submit-button"
              disabled={submitting}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {submitting ? 'Submitting...' : 'Submit Form'}
            </motion.button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}

export default CustomerForm;